export { ProductGrid } from "./product-grid";
